<form [formGroup]="form" (ngSubmit)="save()" class="assignment-form" aria-labelledby="dialog-title">
    <h2 mat-dialog-title id="dialog-title">{{ dialogTitle }}</h2>

    <mat-dialog-content class="dialog-content">
        <!-- Field Selector -->
        <div class="field-selector-container">
            <mat-form-field appearance="outline" floatLabel="always" class="field-selector">
                <mat-label>Add Fields</mat-label>
                <mat-select placeholder="Select fields to add"
                            [value]="activeFields"
                            (selectionChange)="updateFields($event.value)"
                            multiple>
                    <mat-option *ngFor="let field of availableFields"
                                [value]="field.key">
                        {{ field.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-card class="form-card" role="group" aria-label="Assignment fields">
            <div class="form-grid">
                <!-- Consumer -->
                <div class="grid-label">
                    <span>Consumer <span class="req" aria-hidden="true">*</span></span>
                    <span class="cdk-visually-hidden">Required</span>
                </div>
                <div class="grid-control">
                    <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
                        <mat-label>Consumer</mat-label>
                        <mat-select formControlName="consumer" required [disabled]="true" [value]="'COMMERCEPOINT'">
                            <mat-option value="COMMERCEPOINT">CommercePoint</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('consumer')?.hasError('required')">Consumer is required</mat-error>
                    </mat-form-field>
                </div>

                <!-- Location -->
                <div class="grid-label">
                    <span>Location <span class="req" aria-hidden="true">*</span></span>
                    <span class="cdk-visually-hidden">Required</span>
                </div>
                <div class="grid-control">
                    <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
                        <mat-label>Location</mat-label>
                        <mat-select formControlName="location" required>
                            <mat-option *ngFor="let option of locationOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('location')?.hasError('required')">Location is required</mat-error>
                    </mat-form-field>
                </div>

                <!-- Dynamic Fields -->
                <ng-container *ngFor="let fieldKey of activeFields">
                    <div class="grid-label">
                        <span>{{ getFieldLabel(fieldKey) }} <span class="req" aria-hidden="true">*</span></span>
                        <span class="cdk-visually-hidden">Required</span>
                    </div>
                    <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
                        <mat-label>{{ getFieldLabel(fieldKey) }}</mat-label>
                        <mat-select [formControlName]="fieldKey" required>
                            <mat-option *ngFor="let option of getFieldOptions(fieldKey)" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get(fieldKey)?.hasError('required')">This field is required</mat-error>
                    </mat-form-field>
                    <button mat-icon-button
                            type="button"
                            class="remove-field-btn"
                            (click)="removeField(fieldKey)"
                            aria-label="Remove field">
                        <mat-icon>delete</mat-icon>
                    </button>
                </ng-container>
            </div>
        </mat-card>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions-fixed">
        <button mat-raised-button color="primary" type="button" mat-dialog-close (click)="close()">
            Cancel
        </button>

        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
            <mat-icon aria-hidden="true">save</mat-icon> Save
        </button>
    </mat-dialog-actions>
</form>
